var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.663 3.77329C13.8902 2.9834 11.9096 2.78771 10.0166 3.21542C8.12351 3.64314 6.41942 4.67133 5.15845 6.14666C3.89749 7.62199 3.14721 9.4654 3.01951 11.402C2.89181 13.3386 3.39354 15.2645 4.44987 16.8927C5.50619 18.5208 7.06051 19.7638 8.88102 20.4364C10.7015 21.109 12.6907 21.1751 14.5518 20.6248C16.413 20.0745 18.0464 18.9374 19.2084 17.3829C20.3705 15.8285 20.9989 13.9401 21 11.9993V11.0699C21 10.5176 21.4477 10.0699 22 10.0699C22.5523 10.0699 23 10.5176 23 11.0699V11.9999C22.9986 14.3719 22.2306 16.6806 20.8103 18.5804C19.39 20.4803 17.3936 21.8702 15.1189 22.5427C12.8442 23.2153 10.413 23.1345 8.18792 22.3125C5.96285 21.4904 4.06312 19.9711 2.77206 17.9812C1.48099 15.9913 0.86777 13.6373 1.02384 11.2704C1.17992 8.90346 2.09693 6.6504 3.63811 4.84722C5.17929 3.04404 7.26206 1.78736 9.57581 1.2646C11.8896 0.741837 14.3103 0.981007 16.477 1.94644C16.9815 2.17122 17.2082 2.76239 16.9834 3.26687C16.7587 3.77134 16.1675 3.99807 15.663 3.77329Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1757 2.26285C23.5828 2.63604 23.6103 3.26861 23.2372 3.67573L12.2372 15.6757C11.9977 15.9369 11.638 16.0519 11.2914 15.978C10.9449 15.9041 10.6634 15.6524 10.5513 15.3162L8.55131 9.31623C8.37667 8.79229 8.65983 8.22597 9.18377 8.05132C9.70771 7.87667 10.274 8.15983 10.4487 8.68378L11.9112 13.0715L21.7628 2.32428C22.136 1.91716 22.7686 1.88966 23.1757 2.26285Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.34390f63dd7fa782fd1d9154129e7b2f.svg";
export { ForwardRef as ReactComponent };